<template>
	<div class="tab_Topic" v-if="emptyFlag">
	    <ul class="clearfix tabBt_e" :class="{tabBt:false}">
		    <li @click='topicAct(1)' :class="{topic_Active:topicActive==1}"  v-show="infoAnswer">参考答案</li>
	        <li @click='topicAct(3)' :class="{topic_Active:topicActive==3}" v-show="explains[0]">试题解析</li>
	        <li @click='topicAct(2)' :class="{topic_Active:topicActive==2}" v-show="knowledgePoints.length>0">考点</li>
	        <li @click='topicAct(5)' :class="{topic_Active:topicActive==5}" v-show="skillPoints.length>0">能力点</li>
	        <li @click='topicAct(4)' :class="{topic_Active:topicActive==4}" v-show="tags">试题标签</li>
	    </ul>
  	  <div v-if="topicActive==1&&infoAnswer" class="Topic_bg">
  	   	  <span v-if="qtype==1" v-for="(val,answerindex) in infoAnswer">{{val.index | fromCharCode}}</span>
          <span v-if="qtype==2" v-html="setRefAnswer(infoAnswer.options,infoAnswer.ref_info )"></span> 
  	   	  <p v-if="qtype==3" v-for="(val,stemIndex) in infoAnswer">
					 <span v-html="val.stem"></span></p>
  	   	  <p v-if="qtype==8">{{setAnswers(infoAnswer)}}</p>
  	   	  <p v-if="qtype==6" v-html="setShortAnswer(infoAnswer)"></p>
  	  </div>
      <div class="Topic_bg" v-if="topicActive==2">
       	<span class="topc_knowledgeP" v-for="(item,index) in knowledgePoints">{{item.point_displayname}}</span>
      </div>
      <div class="Topic_bg" v-if="topicActive==3&&explains">
         	<div class="clearfix m-b20" v-html="explains[0].context"></div>
         	<div class="m-b20" v-if="explains[0].attachments.length>0" v-for='(item,index) in explains[0].attachments'>
         		<div  v-if="item.file_type==2" class="button" :class="myIsPlay?'play':'pause'" @click="player">
         	    <audio :src="item.file_url" preload="auto"></audio>
         		</div>
          <div class="coverUrl" v-if="item.file_type==3 && videoP" @click="videoPlayer">
            <img :src="item.cover_Url" class="coverVodio">
            <img src="./../../assets/img/player.png" class="coverUrlPlay">
          </div>
          <embed v-show="item.file_type==3 && !videoP" src="http://yuntv.letv.com/bcloud.swf" pic="item.cover_Url" allowFullScreen="true" quality="high"  width="300" height="150" align="middle" allowScriptAccess="always" :flashvars="videoSrc(item.file_url)" type="application/x-shockwave-flash"></embed>
        </div>
        <div v-if='explains[0].lecturer'>
          <b>主讲教师:&nbsp;&nbsp;</b>
          <span>{{explains[0].lecturer}}</span>
          <p style="margin-top:10px;" v-if="explains[0].tags">
            <span class="explains_tag" v-for="(tag, index) in explains[0].tags.split(',')">{{tag}}</span>
          </p>
        </div>
      </div>
      <div class="Topic_bg" v-if="topicActive==4">
       	<span class="explains_tag" v-for="(item,index) in tags">{{item}}</span>
      </div>
      <div v-if="topicActive==5">
        <span class="explains_tag" v-for="(item,index) in skillPoints">{{item}}</span>
      </div>
	</div>
</template>
<script>
  import videoletv from '../player/video.vue'
	export default{
		data(){
			return{
        topicActive:'1',
        videoP:true,
        myIsPlay:false,
        audio:null,
				explainsTags: [],
				emptyFlag: true
			}
		},
		props:[
      'infoAnswer',
      'knowledgePoints',
      'explains',
      'tags',
      'skillPoints',
			'qtype'
		],
    components:{
     videoletv
		},
		created () {
			if (this.infoAnswer) {
				this.topicActive = 1
			} else if (this.knowledgePoints.length > 0){
       this.topicActive = 2
			} else if (this.explains[0]) {
       this.topicActive = 3
			} else if (this.tags) {
       this.topicActive = 4
			} else if (this.skillPoints.length > 0) {
       this.topicActive = 5
			}else {
        this.emptyFlag = false
			}
			this.correctFlag = this.correctFill
		},
		methods:{
			topicAct:function(index){
        this.topicActive = index;
			},
			videoSrc:function(item){
				let src = item.substr(7);
        // return 'http://yuntv.letv.com/bcloud.html?uu=2bfc338ed7&vu='+ src +'&width=300&height=150&&pu=B6999F08EC'
        return 'pu=B6999F08EC&uu=2bfc338ed7&vu='+src+'&auto_play=1&width=656&height=504'
			},
			setAnswers(answers){
			   return  answers.indexOf('1')?'错误':'正确';
			},
			setRefAnswer(options,ref_info){
			    var _this = this;
			    var result = '';
			    for(var i=0;i<options.length;i++){
		        var option = options[i]
		        if(ref_info){    // 不是参考答案
	            for(var j=0;j<ref_info.answers.length;j++){
                var answer = ref_info.answers[j];
                if(answer == option.id){
                    result += String.fromCharCode(65+i) + ' ';
                }
	            }
		        }
			    }
			    return result;
			},
			setShortAnswer(item){
				 if (typeof item == 'string') {
					 try {
						 let data = JSON.parse(item)
						 if (data instanceof Array) {
							 return data.join("/")
						 } else {
							 if (data.instead || data.add || data.isDelete) {
								 let strHtml = ''
								 if (data.instead) {
									 strHtml += '改为' + data.instead + '/'
								 }
								 if (data.add) {
									 strHtml += '单词前加' + data.add + '/'
								 }
								 if (data.isDelete) {
									 strHtml += '删除' + '/'
								 }
								 return strHtml.replace(/\/$/g, '')
							 }
						 }
					 } catch (error) {
						 return item
					 }
				 }
			},
			player:function(){
			  this.audio = document.querySelector('audio');
			  this.audio.play();
        this.myIsPlay = true;
        let _this = this;
        this.audio.addEventListener('ended',function(){
        	_this.myIsPlay = false;
        })
			},
			videoPlayer:function(){
				this.videoP = false;
			}
		}
	}
</script>
	


// WEBPACK FOOTER //
// tabTopic.vue?b8f873a4